import { apiRequest } from '@/core';

export type AdminItemStatus = 'open' | 'resolved' | 'archived';

export type AdminItemType =
  | 'property.submitted_for_review'
  | 'accommodation_request.submitted'
  | 'accommodation_response.accepted'
  | 'accommodation_response.rejected'
  | 'accommodation_request.user_comment_received';

export type AdminItem = {
  id: string;
  type: AdminItemType;
  status: AdminItemStatus;
  message: string;
  message_params: Record<string, number | string | null>;
  meta: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
};

export type AdminItemListResponse = {
  data: AdminItem[];
  links: Record<string, string | null>;
  meta: {
    current_page: number;
    per_page: number;
    last_page: number;
    total: number;
  };
};

export type ListAdminItemsParams = {
  page?: number;
  perPage?: number;
  status?: AdminItemStatus | 'all';
  type?: AdminItemType;
  sort?: string;
};

export const listAdminItems = (params: ListAdminItemsParams = {}) =>
  apiRequest<AdminItemListResponse>({
    endpoint: 'v1/admin-items',
    method: 'GET',
    params: {
      page: params.page,
      per_page: params.perPage,
      'filter[status]': params.status,
      'filter[type]': params.type,
      sort: params.sort,
    },
  });

export const getAdminItemsOpenCount = () =>
  apiRequest<{ open_count: number }>({
    endpoint: 'v1/admin-items/open-count',
  });

export const resolveAdminItem = (id: string) =>
  apiRequest<{ message: string }>({
    endpoint: `v1/admin-items/${id}/resolve`,
    method: 'PATCH',
  });

export const archiveAdminItem = (id: string) =>
  apiRequest<{ message: string }>({
    endpoint: `v1/admin-items/${id}/archive`,
    method: 'PATCH',
  });
